// @flow

import { Dialog } from 'app/rgs/utils';

import template from '../../templates/modal/template.html';
import { SelectBaseStrategy } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import ko from 'rgs-knockout';
import {lkTypes} from "../../index";

import LkTypeStorageExecutor from '../utils/lk-type-storage-executor';

interface ILkTypeModalParams {
  onSubmitClick: (args) => void;
  creds: {email: string, password: string};
  companies: any[] // TODO: type

}

class LkTypeDialog extends Dialog {
	_params: ILkTypeModalParams;
	_lkTypeStorage: LkTypeStorageExecutor;
	companySelectStrategy: $NonMaybeType<SelectBaseStrategy<any>>;

	constructor (params: ILkTypeModalParams) {
		super();
		this._params = params;
		this.props = {
		    handleContinueClick: this._handleSubmit,
			lkType: ko.observable('juridical'),
			selectedCompany: ko.observable(''),
			companies: params.companies,
			cancel: this.cancel.bind(this)
		};

		this._lkTypeStorage = new LkTypeStorageExecutor();

		this.companySelectStrategy = new SelectBaseStrategy({
			Items: this._params.companies
		});

		this._lkTypeStorage = new LkTypeStorageExecutor();

		this._lkTypeStorage = new LkTypeStorageExecutor();
	}

	_handleSubmit = () => {
		let returnVal = {
			...this._params.creds,
			LkType: lkTypes[this.props.lkType()]
		};
		if (this.props.lkType() === 'juridical') {
			returnVal.InsurantId = this.props.selectedCompany();
		}

		this._lkTypeStorage.setLkType(returnVal.LkType);
		this._lkTypeStorage.setLkCompany(returnVal.InsurantId);

		this._params.onSubmitClick(returnVal);
		this._hide();
	};

	init () {
		this._dialog = this._create({
			templateMode: 'nfd-content',
			template: {
				html: template(),
				data: this,
			},
			userCanClose: false,
		});
		return this;
	}

	cancel () {
		this._hide();
	}

	show () {
		this._show();
	}
}

export {
  LkTypeDialog,
};
